import taskTrace from './view/taskTrace.html'

export default {
  base: {
    state: 'declaration.corporateIncomeTax.taskTrace',
    config: {
      url: '/taskTrace',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.corporateIncomeTax.taskTrace.list',
      title: '申报任务跟踪',
    },
  },
  list: {
    state: 'declaration.corporateIncomeTax.taskTrace.list',
    config: {
      url: '/list',
      template: taskTrace,
      controller: 'taskTraceCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/taskTrace/routers.js